<template>
  <div
    class="top-fix-banner"
    :class="data.topFixVariant ? data.topFixVariant : 'fix-black'"
  >
    <b-row v-if="!data.icon" align-v="center">
      <b-col cols="auto" class="mx-auto">
        <div v-html="data.topFixMessage"></div>
      </b-col>
    </b-row>
    <b-row v-else align-v="center">
      <b-col cols="auto" class="mx-auto">
        <b-media no-body class="mr-4">
          <b-media-aside vertical-align="center" class="mr-3">
            <img
              src="@/assets/img/icons/bell-yellow.svg"
              width="24"
              class="align-text-bottom"
              alt=""
            />
          </b-media-aside>
          <b-media-body v-html="data.topFixMessage"></b-media-body>
        </b-media>
      </b-col>
    </b-row>
    <button
      v-if="data.haveClose"
      type="button"
      class="close"
      aria-label="Close"
      @click="$emit('close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <span v-if="data.haveParticle" class="particle-fix-banner parti-1">
      <img src="@/assets/img/icons/dashboard/parti-fix-top-1.png" />
    </span>
    <span v-if="data.haveParticle" class="particle-fix-banner parti-2">
      <img src="@/assets/img/icons/dashboard/parti-fix-top-2.png" />
    </span>
  </div>
</template>

<script>
import { getTopFixedMessage } from "@/common/functions";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      data: {},
    };
  },
  methods: {
    closeBanner() {
      this.$store.commit("dashboard/setShowLifetimeSuccess", false);
    },
  },
  computed: {
    ...mapState({
      showLifetimeSuccess: (state) => state.dashboard.showLifetimeSuccess,
    }),
  },
  created() {
    var messages = getTopFixedMessage(this, this.showLifetimeSuccess);
    if (messages) {
      this.data = messages;
      if (this.showLifetimeSuccess) {
        setTimeout(() => {
          this.closeBanner();
        }, 8000);
      }
    }
  },
};
</script>
